import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { addProjectApi, deleteProjectApi, getProjectsApi } from '../api/projectAPI';
import { addEconomics, updateEconomics } from './economicsSlice';

import { addList, addLists, addPetroNinjaList, deleteList } from './listSlice';

const initialState = {
  byId: {},
  allIds: [],
  currentProjectId: ""
};

export const getProjects = createAsyncThunk(
  'projects/getProjects',
  async (payload) => {
    try {
      const { projects, lists, wells, economics } = await getProjectsApi(payload.email);

      return { projects: projects, lists: lists, wells: wells, economics: economics };
    } catch (error) {
      return;
    };
  }
);

export const addProject = createAsyncThunk(
  'projects/addProject',
  async (payload) => {
    try {
      if (!payload.demoUser) {
        await addProjectApi(payload.project, payload.lists, payload.email);
      };
      return { project: payload.project };
    } catch (error) {
      return;
    };
  }
);

export const deleteProject = createAsyncThunk(
  'projects/deleteProject',
  async (payload) => {
    try {
      await deleteProjectApi(payload.projectId);
      return { projectId: payload.projectId };
    } catch (error) {
      return;
    };
  }
);

// export const loadProject = createAsyncThunk(
//   'projects/loadProject',
//   async (payload) => {
//     try {
//       await loadProjectApi(payload.projectId);
//       return { projectId: payload.projectId, lists: };
//     } catch (error) {
//       return;
//     };
//   }
// );

// export const saveProject = createAsyncThunk(
//   'projects/saveProject',
//   async (payload) => {
//     try {
//       await saveProjectApi(payload.project, payload.lists);
//       return true;
//     } catch (error) {
//       return false;
//     };
//   }
// );

export const projectSlice = createSlice({
  name: 'projects',
  initialState,
  reducers: {
    
    // addProject: (state, action) => {
    //   const projectId = action.payload.id;
    //   state.byId[projectId] = action.payload;
    //   state.allIds.push(projectId);
    //   state.currentProjectId = projectId;
    // },
    importProject: (state, action) => {
      try {
        const project = action.payload.project;
        const email = action.payload.email;
        const id = action.payload.id;
        const listIds = action.payload.listIds;
        state.byId[id] = {...project, id, createdBy: email, listIds};
        if (state.allIds.indexOf(id) === -1) state.allIds.push(id);
        state.currentProjectId = id;
      } catch (error) {
        return;
      };
    },
    updateProject: (state, action) => {
      try {
        const project = action.payload.project;
        const projectId = action.payload.projectId;
        state.byId[projectId] = project;
      } catch (error) {
        return;
      };
    },
    makeProjectCurrent: (state, action) => {
      const projectId = action.payload;
      state.currentProjectId = projectId;
    },
    makeListCurrent: (state, action) => {
      const { projectId, listId } = action.payload;
      state.byId[projectId].currentListId = listId;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getProjects.fulfilled, (state, action) => {
      try {
        const projects = action.payload.projects;
        if (projects?.length > 0) {
          projects.forEach(project => {
            state.byId[project.id] = project;
            if (state.allIds.indexOf(project.id) === -1) state.allIds.push(project.id);
          });
          const filteredProjects = state.allIds.filter(id => !state.byId[id]?.public);
          state.currentProjectId = filteredProjects[filteredProjects.length-1];
        };
      } catch (error) {
        return;
      };
    })
    builder.addCase(addProject.fulfilled, (state, action) => {
      const project = action.payload.project;
      state.byId[project.id] = project;
      if (state.allIds.indexOf(project.id) === -1) state.allIds.push(project.id);
      state.currentProjectId = project.id;
    })
    builder.addCase(deleteProject.fulfilled, (state, action) => {
      try {
        const projectId = action.payload.projectId;
        delete state.byId[projectId];
        state.allIds = state.allIds.filter(id => id !== projectId);
        state.currentProjectId = state.allIds[0] || ""
      } catch (error) {};
    })
    builder.addCase(addList.fulfilled, (state, action) => {
      const { projectId, list } = action.meta.arg;
      if (state.byId[projectId]?.listIds?.indexOf(list.id) === -1) state.byId[projectId]?.listIds?.push(list.id);
      state.byId[projectId].currentListId = list.id;
    })
    builder.addCase([addLists], (state, action) => {
      const { projectId, lists } = action.meta.arg;
      lists.allIds.forEach(listId => {
        if (state.byId[projectId].listIds.indexOf(listId) === -1) state.byId[projectId].listIds.push(listId);
      });
      state.byId[projectId].currentListId = lists[lists.length - 1].id;
    })
    builder.addCase(addPetroNinjaList.fulfilled, (state, action) => {
      try {
        const projectId = action.meta.arg;
        const list = action.payload?.list;
        if (state.byId[projectId].listIds.indexOf(list.id) === -1) state.byId[projectId].listIds.push(list.id);
        state.byId[projectId].currentListId = list.id;
      } catch (error) {};
    })
    builder.addCase(deleteList.fulfilled, (state, action) => {
      const { projectId, listId } = action.meta.arg;
      state.byId[projectId].listIds = state.byId[projectId].listIds.filter(id => id !== listId);
    })
    builder.addCase(addEconomics.fulfilled, (state, action) => {
      try {
        const { economics, projectId } = action.meta.arg;
        if (state.byId[projectId].economicsIds.indexOf(economics.id) === -1) state.byId[projectId].economicsIds.push(economics.id);
      } catch (error) {
        console.log(error);
      };
    })
    builder.addCase(updateEconomics.fulfilled, (state, action) => {
      try {
        const { economics, projectId } = action.meta.arg;
        if (!state.byId[projectId]) {
          return;
        } else if (state.byId[projectId].economicsIds.indexOf(economics.id) === -1) {
          state.byId[projectId].economicsIds.push(economics.id);
        };
      } catch (error) {
        console.log(error);
      };
    })
    // builder.addCase(deleteEconomics.fulfilled, (state, action) => {
    //   try {
    //     const economicsId = action.meta.arg;

    //     if (!economicsId) return;

    //     state.allIds.forEach(id => {
    //       state.byId[id].economicsIds = state.byId.economicsIds.filter(econId => econId !== economicsId);
    //     });
    //   } catch (error) {
    //     console.log(error);
    //   };
    // })
  }
});

export const { importProject, updateProject, makeProjectCurrent, makeListCurrent } = projectSlice.actions;

export const selectProjects = (state) => state.projects;

export default projectSlice.reducer;